'use client';

import React from 'react';
import { Flex } from '@skin-seoul/design-system';
import type { ProductCardProps } from '../ProductCard.types';
import { ProductCardProvider } from '../ProductCardContext';
import ProductCardInfoName from '../components/ProductCardInfoName';
import ProductCardInfoRating from '../components/ProductCardInfoRating';
import { ProductCardInfoPrice } from '../components/ProductCardInfoPrice';
import { HorizontalProductCardContent } from './HorizontalProductCardContent';
import { HorizontalProductCardImage } from './HorizontalProductCardImage';

export const HorizontalProductCard = ({
  children,
  theme,
  onClick,
  ranking,
  orientation = 'horizontal',
  ...componentProps
}: ProductCardProps) => {
  return (
    <ProductCardProvider
      value={{
        ...componentProps,
        orientation,
        theme,
        ranking,
      }}
    >
      <Flex width="100%" h={ranking ? '164px' : '136px'} position="relative">
        <Flex
          borderRadius="8px"
          backgroundColor={theme === 'dark' ? 'generic.100' : 'generic.0'}
          direction="row"
          height="100%"
          width="100%"
          alignItems="center"
          cursor="pointer"
          onClick={(e) => {
            e.stopPropagation();
            onClick?.(e);
          }}
        >
          <>{children}</>
        </Flex>
      </Flex>
    </ProductCardProvider>
  );
};

HorizontalProductCard.Content = HorizontalProductCardContent;
HorizontalProductCard.Image = HorizontalProductCardImage;
HorizontalProductCard.InfoName = ProductCardInfoName;
HorizontalProductCard.InfoRating = ProductCardInfoRating;
HorizontalProductCard.InfoPrice = ProductCardInfoPrice;
